// @ts-nocheck
import React from "react";
import SocialMediaManagement from "@/components/social/SocialMediaManagement";

const SocialMediaManagementPage: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Social Media Management</h1>
          <p className="text-muted-foreground">
            Manage and sync your social media posts from Instagram and X (Twitter)
          </p>
        </div>
      </div>
      
      <SocialMediaManagement />
    </div>
  );
};

export default SocialMediaManagementPage;